'use client';

import { c as _c } from "react/compiler-runtime";
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import { Badge } from '@repo/ui/components';
import { Download, Upload } from '@repo/ui/icons';
import { RouteMapMarkerProps } from './route-map.tsx';
const getDropMarkerLabel = (type: RouteMapMarkerProps['drop']['type'], stopNumber: number) => {
  if (type === 'delivery') {
    return `Delivery stop ${stopNumber}`;
  }
  return `Collection stop ${stopNumber}`;
};
export const DefaultRouteMarker = t0 => {
  const $ = _c(14);
  const {
    drop,
    index,
    point
  } = t0;
  const stopNumber = index + 1;
  const isDelivery = drop.type === "delivery";
  const Icon = isDelivery ? Upload : Download;
  let t1;
  if ($[0] !== drop.type || $[1] !== stopNumber) {
    t1 = getDropMarkerLabel(drop.type, stopNumber);
    $[0] = drop.type;
    $[1] = stopNumber;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== Icon) {
    t2 = <Icon className="size-3" strokeWidth={2.5} data-sentry-element="Icon" data-sentry-source-file="default-route-marker.tsx" />;
    $[3] = Icon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== stopNumber) {
    t3 = <span className="min-w-4 text-center text-xs leading-none font-semibold">{stopNumber}</span>;
    $[5] = stopNumber;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <Badge className="rounded-full border-transparent bg-black px-2 py-1 text-white shadow-sm" data-sentry-element="Badge" data-sentry-source-file="default-route-marker.tsx">{t2}{t3}</Badge>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== point || $[11] !== t1 || $[12] !== t4) {
    t5 = <AdvancedMarker position={point} title={t1} data-sentry-element="AdvancedMarker" data-sentry-component="DefaultRouteMarker" data-sentry-source-file="default-route-marker.tsx">{t4}</AdvancedMarker>;
    $[10] = point;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};